export default {"src":"/polygon/_next/static/media/autofarm.6ab93f86.svg","height":59,"width":60};